import React from 'react';
import { TouchableOpacity } from 'react-native';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { Ionicons } from '../components/ui/Icon';
import type { SettingsStackParamList } from './types';
import { makePlaceholder } from '../screens/Placeholder';
import { colors, fonts } from '../constants/theme';
// P3 SETTINGS group — ported screens (index, security, privacy, data-privacy, blocked).
import SettingsIndexScreen from '../app/settings';
import SecurityScreen from '../app/settings/security';
import PrivacyScreen from '../app/settings/privacy';
import DataPrivacyScreen from '../app/settings/data-privacy';
import BlockedScreen from '../app/settings/blocked';
// P3 wave-2 SETTINGS-REMAINDER group — ported screens.
import AccountScreen from '../app/settings/account';
import AppearanceScreen from '../app/settings/appearance';
import LanguageScreen from '../app/settings/language';
import MutedWordsScreen from '../app/settings/muted-words';
import MutedScreen from '../app/settings/muted';
// P3 WIRING — ported notification-preference toggles (real source in cryb-native).
import NotificationsSettingsScreen from '../app/settings/notifications';

const Stack = createNativeStackNavigator<SettingsStackParamList>();

export function SettingsStack() {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: true,
        headerTitleStyle: { ...fonts.semibold, fontSize: 17, color: colors.ink },
        headerTintColor: colors.primary,
        headerStyle: { backgroundColor: colors.bg },
        headerShadowVisible: false,
      }}
    >
      <Stack.Screen
        name="SettingsIndex"
        component={SettingsIndexScreen}
        options={({ navigation }) => ({
          title: 'Settings',
          // Root of the nested stack has no default back; add one that bubbles to
          // the parent (RootStack) so Settings can be dismissed (#85 — was stuck).
          headerLeft: () => (
            <TouchableOpacity
              onPress={() => navigation.goBack()}
              hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
              accessibilityRole="button"
              accessibilityLabel="Back"
            >
              <Ionicons name="chevron-back" size={26} color={colors.primary} />
            </TouchableOpacity>
          ),
        })}
      />
      <Stack.Screen name="SettingsAccount" component={AccountScreen} options={{ title: 'Account' }} />
      <Stack.Screen name="SettingsAppearance" component={AppearanceScreen} options={{ title: 'Appearance' }} />
      <Stack.Screen name="SettingsBlocked" component={BlockedScreen} options={{ title: 'Blocked' }} />
      <Stack.Screen name="SettingsDataPrivacy" component={DataPrivacyScreen} options={{ title: 'Data & Privacy' }} />
      {/* Developer platform — v2-gated (SHOW_DEVELOPER). Coming-soon placeholder
          so the route resolves; real screens land in CRYB v2. */}
      <Stack.Screen name="SettingsDeveloper" component={makePlaceholder('Developer')} options={{ title: 'Developer' }} />
      <Stack.Screen name="SettingsExchanges" component={makePlaceholder('Exchanges')} options={{ title: 'Exchanges' }} />
      <Stack.Screen name="SettingsLanguage" component={LanguageScreen} options={{ title: 'Language & Region' }} />
      <Stack.Screen name="SettingsMutedWords" component={MutedWordsScreen} options={{ title: 'Muted Words' }} />
      <Stack.Screen name="SettingsMuted" component={MutedScreen} options={{ title: 'Muted Users' }} />
      <Stack.Screen name="SettingsNotifications" component={NotificationsSettingsScreen} options={{ title: 'Notifications' }} />
      <Stack.Screen name="SettingsPrivacy" component={PrivacyScreen} options={{ title: 'Privacy' }} />
      <Stack.Screen name="SettingsSecurity" component={SecurityScreen} options={{ title: 'Security' }} />
    </Stack.Navigator>
  );
}
